export default __webpack_public_path__ + "static/media/icon-file-check.f769baed.svg";